module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c0933a65c76caab1d5d52bd21c1495e9.png";